import { useEffect } from 'react';

const SEO = ({ 
  title = 'Vocavi Partners | Executive Search & Leadership Hiring',
  description = 'Vocavi Partners LLP is a premier executive search firm in Gurugram, India specializing in leadership hiring across Manufacturing, Engineering, Automation, Fashion & Apparel, Energy and Emerging Technology sectors.',
  keywords = 'executive search, leadership hiring, headhunting, Gurugram, India, manufacturing recruitment, engineering jobs, automation careers, fashion industry jobs, energy sector recruitment, C-suite hiring',
  image = 'https://vocavi-exec-search.preview.emergentagent.com/og-image.png',
  url = 'https://vocavi.in',
  type = 'website',
  author = 'Vocavi Partners LLP',
  canonical = ''
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tags
    const updateMetaTag = (property, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Helper function to update or create link tags
    const updateLinkTag = (rel, href) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', rel);
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', author);
    updateMetaTag('robots', 'index, follow');

    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', image, true);
    updateMetaTag('og:url', canonical || url, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:site_name', 'Vocavi Partners', true);
    updateMetaTag('og:locale', 'en_IN', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);

    // Canonical URL
    if (canonical) {
      updateLinkTag('canonical', canonical);
    }

  }, [title, description, keywords, image, url, type, author, canonical]);

  return null;
};

// Pre-defined SEO configs for different pages
export const SEO_CONFIGS = {
  home: {
    title: 'Vocavi Partners | Executive Search & Leadership Hiring in India',
    description: 'Vocavi Partners LLP is a premier executive search firm in Gurugram, India. We specialize in C-suite and senior leadership hiring across Manufacturing, Engineering, Automation, Fashion, Energy and Technology sectors.',
    keywords: 'executive search India, leadership hiring Gurugram, headhunting services, C-suite hiring, senior management recruitment, talent acquisition India',
    canonical: 'https://vocavi.in'
  },
  about: {
    title: 'About Us | Vocavi Partners - Executive Search Experts',
    description: 'Learn about Vocavi Partners LLP, our mission, values, and commitment to connecting exceptional leaders with transformative opportunities in India and beyond.',
    keywords: 'about Vocavi Partners, executive search company, recruitment agency India, leadership consultants Gurugram',
    canonical: 'https://vocavi.in/about'
  },
  sectors: {
    title: 'Industry Sectors | Vocavi Partners - Specialized Executive Search',
    description: 'Vocavi Partners provides specialized executive search services across Manufacturing, Engineering, Automation, Fashion & Apparel, Energy, and Emerging Technology sectors.',
    keywords: 'industry sectors recruitment, manufacturing executives, engineering leadership, automation specialists, fashion industry hiring, energy sector recruitment, tech leadership',
    canonical: 'https://vocavi.in/sectors'
  },
  jobs: {
    title: 'Open Positions | Vocavi Partners - Executive Career Opportunities',
    description: 'Explore current executive and leadership positions available through Vocavi Partners. Find C-suite, VP, and director-level opportunities across multiple industries.',
    keywords: 'executive jobs India, leadership positions, C-suite opportunities, director jobs, VP positions, senior management careers',
    canonical: 'https://vocavi.in/jobs'
  },
  blogs: {
    title: 'Insights & Blogs | Vocavi Partners - Leadership Trends',
    description: 'Stay updated with the latest insights on executive search, leadership trends, industry news, and career advice from Vocavi Partners experts.',
    keywords: 'executive search blog, leadership insights, recruitment trends, career advice, industry news, talent management',
    canonical: 'https://vocavi.in/blogs'
  },
  methodology: {
    title: 'Our Methodology | Vocavi Partners - Executive Search Process',
    description: 'Discover our proven executive search methodology that ensures we find the right leadership talent for your organization. Our rigorous process delivers results.',
    keywords: 'executive search process, recruitment methodology, talent assessment, leadership evaluation, hiring process',
    canonical: 'https://vocavi.in/methodology'
  },
  contact: {
    title: 'Contact Us | Vocavi Partners - Get in Touch',
    description: 'Contact Vocavi Partners LLP for executive search and leadership recruitment services. Based in Gurugram, India. Email: connect@vocavi.in',
    keywords: 'contact Vocavi Partners, executive search inquiry, recruitment services contact, Gurugram headhunters',
    canonical: 'https://vocavi.in/contact'
  }
};

export default SEO;
